import React from 'react'
import styled from 'styled-components'
import Container from 'components/Container'

const Page = ({ children }) => (
  <StyledPage>
    <StyledMain>{children}</StyledMain>
    <Container size="sm">
      <p>You Bet! provides the service that allows eligible entities to create 
      their own raffles. It is such entity's own responsibility to know 
      whether you are eligible to run it. Unfortunately, since our service is
      fully decentralized, the technology is not available for You Bet! to help
      you find out whether you are eligible. We are not responsible for pool
      owner's behavior. </p>
      <p>While we can't offer you legal advice, if you are a US resident, we 
      highly recommend that you get familiar with 
      <a href="https://chance2win.org/us-online-legal-raffle/"> your local raffle regulations </a>
       before using our service. </p>
    </Container>
  </StyledPage>
)

const StyledPage = styled.div``

const StyledMain = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - ${(props) => props.theme.topBarSize * 2}px);
`

export default Page
